import React, { useEffect, useRef, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { academydetail, feedashboardcount, feeinvoicelist, studentview } from "../service/dashboard";
import moment from "moment";

function numberToWords(num) {
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
        "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty",
        "Sixty", "Seventy", "Eighty", "Ninety"];
    const convertTens = (n) => {
        if (n < 10) return ones[n];
        if (n < 20) return teens[n - 10];
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    };
    let result = "";
    if (num >= 1000) { result += convertTens(Math.floor(num / 1000)) + " Thousand "; num %= 1000; }
    if (num >= 100) { result += ones[Math.floor(num / 100)] + " Hundred "; num %= 100; }
    if (num > 0) { if (result !== "") result += "and "; result += convertTens(num); }
    return result.trim() + " Rupees Only";
}

const TYPE_COLORS = ["#6259ca", "#09ad95", "#f7b731", "#e74c3c", "#2196f3", "#ff6b35"];

const FeeReport = () => {
    const [feelist, setFeeList] = useState([]);
    const [summaryData, setSummaryData] = useState({});
    const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
    const [school, setSchool] = useState(null);

    const [page, setPage] = useState(1);
    const PAGE_SIZE = 10;

    const [showModal, setShowModal] = useState(false);
    const [invData, setInvData] = useState([]);
    const [invNo, setInvNo] = useState(null);
    const printRef = useRef();

    useEffect(() => {
        studentview(localStorage.getItem("UID")).then((res) => {
            if (res.status === true) {
                const det = res.data.details;
                academydetail(det.academy_id).then((r) => {
                    if (r.status === true) setSchool(r.data.details);
                });
                fetchFees(fromDate, toDate);
            }
        });
    }, []);

    function fetchFees(fdate, tdate) {
        const temp = new FormData();
        temp.append("from_date", fdate);
        temp.append("to_date", tdate);
        temp.append("student", localStorage.getItem("UID"));
        feedashboardcount(temp).then((res) => {
            if (res.status === true) {
                const list = res.data.details || [];
                setPage(1);
                setFeeList(list.map((item) => ({
                    ...item,
                    inv_date: item.paid_date,
                    paid_date_fmt: item.paid_date ? moment(item.paid_date).format("DD-MM-YYYY") : "",
                })));
                const summary = {};
                list.forEach((item) => {
                    const type = item.fee_type || "Other";
                    if (!summary[type]) summary[type] = { total: 0, paid: 0, discount: 0 };
                    summary[type].paid += parseFloat(item.paid_amount || 0);
                    summary[type].discount += parseFloat(item.disc_amt || 0);
                    summary[type].total += parseFloat(item.amount || 0);
                });
                setSummaryData(summary);
            }
        });
    }

    function openInvoice(studentId, payDate) {
        const temp = new FormData();
        temp.append("student_id", studentId);
        temp.append("payment_date", payDate);
        feeinvoicelist(temp).then((res) => {
            if (res.status === true && Array.isArray(res.data) && res.data.length > 0) {
                setInvData(res.data);
                setInvNo(res.data[0]);
                setShowModal(true);
            }
        });
    }

    function handlePrint() {
        setShowModal(false);
        const printContents = printRef.current.innerHTML;
        const win = window.open("", "", "height=700,width=900");
        win.document.write(`
            <html><head><title>Fee Receipt</title>
            <style>
                * { box-sizing: border-box; }
                body { font-family: Arial, sans-serif; background: #f5f5f5; padding: 20px; }
                .receipt { width: 600px; margin: 0 auto; background: #fff; border: 2px solid #6259ca; border-radius: 8px; overflow: hidden; }
                .receipt-header { background: #6259ca; color: #fff; padding: 16px 20px; }
                .receipt-header h2 { margin: 0; font-size: 18px; }
                .receipt-header p { margin: 4px 0 0; font-size: 12px; opacity: 0.85; }
                .receipt-badge { background: rgba(255,255,255,0.2); display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 11px; margin-top: 6px; letter-spacing: 1px; }
                .receipt-body { padding: 20px; }
                .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 16px; font-size: 13px; }
                .info-row { padding: 4px 0; border-bottom: 1px dashed #eee; }
                .divider { border: none; border-top: 2px dashed #6259ca; margin: 14px 0; }
                table { width: 100%; border-collapse: collapse; font-size: 13px; }
                th { background: #6259ca; color: #fff; padding: 8px 10px; text-align: left; }
                td { padding: 8px 10px; border-bottom: 1px solid #eee; }
                .total-row td { font-weight: bold; background: #f0effe; border-top: 2px solid #6259ca; }
                .words { font-size: 12px; color: #555; margin-top: 12px; font-style: italic; }
                .footer-row { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 28px; font-size: 12px; color: #555; }
                .stamp { color: #27ae60; font-weight: bold; font-size: 20px; border: 3px solid #27ae60; display: inline-block; padding: 2px 10px; border-radius: 4px; transform: rotate(-5deg); opacity: 0.7; letter-spacing: 2px; }
            </style>
            </head><body>${printContents}</body></html>
        `);
        win.document.close();
        win.focus();
        win.print();
        setTimeout(() => win.close(), 1000);
    }

    const invTotal = invData.reduce((s, f) => s + parseFloat(f.payment_amount || 0), 0);
    const summaryEntries = Object.entries(summaryData);

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={8} className="text-left align-self-end">
                            <h4 className="morehead-text">Fee Report</h4>
                        </Col>
                        <Col xs={4} className="text-right align-self-end">
                            <Link to="/dashboard" className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>

                <div className="p-3">
                    {/* Date Filters */}
                    <Row className="mb-3">
                        <Col xs={6}>
                            <label className="form-label attachment">From Date</label>
                            <input type="date" className="form-control" value={fromDate}
                                onChange={(e) => { setFromDate(e.target.value); fetchFees(e.target.value, toDate); }} />
                        </Col>
                        <Col xs={6}>
                            <label className="form-label attachment">To Date</label>
                            <input type="date" className="form-control" value={toDate}
                                onChange={(e) => { setToDate(e.target.value); fetchFees(fromDate, e.target.value); }} />
                        </Col>
                    </Row>

                    {/* ── SUMMARY SECTION ── */}
                    {summaryEntries.length > 0 && (
                        <>
                            <p className="fw-bold mb-2" style={{ color: "#6259ca", fontSize: "13px", letterSpacing: "0.5px" }}>
                                FEE SUMMARY
                            </p>
                            {summaryEntries.map(([type, vals], idx) => {
                                const color = TYPE_COLORS[idx % TYPE_COLORS.length];
                                const pending = vals.total - vals.paid - vals.discount;
                                return (
                                    <div key={idx} className="mb-2 rounded-3 overflow-hidden"
                                        style={{ border: `1px solid ${color}22`, background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.07)" }}>
                                        <div className="px-3 py-2 d-flex align-items-center"
                                            style={{ background: color, color: "#fff" }}>
                                            <i className="fas fa-tag me-2" style={{ fontSize: "12px" }}></i>
                                            <span className="fw-bold" style={{ fontSize: "13px" }}>{type}</span>
                                        </div>
                                        <div className="px-3 py-2">
                                            <Row className="text-center g-0">
                                                <Col xs={3}>
                                                    <div className="fw-bold" style={{ color, fontSize: "14px" }}>₹{vals.total.toFixed(0)}</div>
                                                    <small className="text-muted" style={{ fontSize: "10px" }}>Total</small>
                                                </Col>
                                                <Col xs={3}>
                                                    <div className="fw-bold text-success" style={{ fontSize: "14px" }}>₹{vals.paid.toFixed(0)}</div>
                                                    <small className="text-muted" style={{ fontSize: "10px" }}>Paid</small>
                                                </Col>
                                                <Col xs={3}>
                                                    <div className="fw-bold text-warning" style={{ fontSize: "14px" }}>₹{vals.discount.toFixed(0)}</div>
                                                    <small className="text-muted" style={{ fontSize: "10px" }}>Discount</small>
                                                </Col>
                                                <Col xs={3}>
                                                    <div className="fw-bold text-danger" style={{ fontSize: "14px" }}>₹{pending.toFixed(0)}</div>
                                                    <small className="text-muted" style={{ fontSize: "10px" }}>Pending</small>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}

                    {/* ── FEE PAYMENT LIST ── */}
                    {feelist.length > 0 && (() => {
                        const totalPages = Math.ceil(feelist.length / PAGE_SIZE);
                        const pageItems = feelist.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
                        return (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-2 mt-3">
                                    <p className="fw-bold mb-0" style={{ color: "#6259ca", fontSize: "13px", letterSpacing: "0.5px" }}>
                                        PAYMENT HISTORY
                                    </p>
                                    <small style={{ color: "#888", fontSize: "11px" }}>
                                        {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, feelist.length)} of {feelist.length}
                                    </small>
                                </div>

                                {pageItems.map((item, idx) => {
                                    const color = TYPE_COLORS[((page - 1) * PAGE_SIZE + idx) % TYPE_COLORS.length];
                                    const isPaid = parseFloat(item.pending_amount || 0) <= 0;
                                    return (
                                        <div key={idx} className="mb-3 rounded-3 overflow-hidden"
                                            style={{ background: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", borderLeft: `4px solid ${color}` }}>
                                            <div className="px-3 pt-2 pb-1">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span className="fw-bold" style={{ fontSize: "14px" }}>{item.fee_type}</span>
                                                    <button
                                                        className="btn btn-sm py-0 px-2"
                                                        style={{ fontSize: "11px", background: "#6259ca", color: "#fff", borderRadius: "12px" }}
                                                        onClick={() => openInvoice(item.student_id, item.inv_date)}
                                                    >
                                                        <i className="fas fa-receipt me-1"></i> Invoice
                                                    </button>
                                                </div>
                                                <div className="d-flex justify-content-between mt-1">
                                                    <small style={{ color: "#888", fontSize: "11px" }}>
                                                        <i className="fas fa-calendar-alt me-1"></i>{item.paid_date_fmt}
                                                    </small>
                                                    <small style={{ color: "#888", fontSize: "11px" }}>{item.aca_year}</small>
                                                </div>
                                            </div>
                                            <div style={{ borderTop: "1px dashed #eee", margin: "0 12px" }}></div>
                                            <div className="px-3 py-2">
                                                <Row className="text-center g-0">
                                                    <Col xs={4}>
                                                        <div className="fw-bold" style={{ color, fontSize: "15px" }}>
                                                            ₹{parseFloat(item.amount || 0).toFixed(0)}
                                                        </div>
                                                        <small style={{ color: "#999", fontSize: "10px" }}>Total</small>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <div className="fw-bold text-success" style={{ fontSize: "15px" }}>
                                                            ₹{parseFloat(item.paid_amount || 0).toFixed(0)}
                                                        </div>
                                                        <small style={{ color: "#999", fontSize: "10px" }}>Paid</small>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <div className="fw-bold" style={{ color: isPaid ? "#27ae60" : "#e74c3c", fontSize: "15px" }}>
                                                            ₹{parseFloat(item.pending_amount || 0).toFixed(0)}
                                                        </div>
                                                        <small style={{ color: "#999", fontSize: "10px" }}>Pending</small>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="px-3 pb-2 d-flex justify-content-between align-items-center">
                                                <span style={{
                                                    fontSize: "10px", fontWeight: "bold", padding: "2px 8px",
                                                    borderRadius: "10px", letterSpacing: "0.5px",
                                                    background: isPaid ? "#e8f8f2" : "#fef0f0",
                                                    color: isPaid ? "#27ae60" : "#e74c3c",
                                                }}>
                                                    {isPaid ? "✓ PAID" : "● PENDING"}
                                                </span>
                                                {item.paid_by && (
                                                    <small style={{ color: "#999", fontSize: "11px" }}>
                                                        via <strong>{item.paid_by}</strong>
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* Pagination controls */}
                                {totalPages > 1 && (
                                    <div className="d-flex justify-content-center align-items-center gap-2 pb-2" style={{ gap: "8px" }}>
                                        <button
                                            className="btn btn-sm"
                                            style={{
                                                background: page === 1 ? "#eee" : "#6259ca",
                                                color: page === 1 ? "#aaa" : "#fff",
                                                borderRadius: "8px", minWidth: "36px", fontSize: "13px"
                                            }}
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            ‹
                                        </button>

                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                                            <button
                                                key={p}
                                                className="btn btn-sm"
                                                style={{
                                                    background: p === page ? "#6259ca" : "#f0effe",
                                                    color: p === page ? "#fff" : "#6259ca",
                                                    borderRadius: "8px", minWidth: "36px",
                                                    fontWeight: p === page ? "bold" : "normal",
                                                    fontSize: "13px"
                                                }}
                                                onClick={() => setPage(p)}
                                            >
                                                {p}
                                            </button>
                                        ))}

                                        <button
                                            className="btn btn-sm"
                                            style={{
                                                background: page === totalPages ? "#eee" : "#6259ca",
                                                color: page === totalPages ? "#aaa" : "#fff",
                                                borderRadius: "8px", minWidth: "36px", fontSize: "13px"
                                            }}
                                            disabled={page === totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            ›
                                        </button>
                                    </div>
                                )}
                            </>
                        );
                    })()}

                    {feelist.length === 0 && (
                        <p className="text-center text-danger fw-bold mt-4">No fee records found.</p>
                    )}
                </div>
            </div>

            {/* ── INVOICE MODAL — formal receipt document style ── */}
            {showModal && (
                <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1050 }}>
                    <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: "95vw", margin: "20px auto" }}>
                        <div className="modal-content" style={{ borderRadius: "12px", overflow: "hidden", border: "none" }}>

                            {/* Modal action bar */}
                            <div className="d-flex justify-content-between align-items-center px-3 py-2"
                                style={{ background: "#6259ca", color: "#fff" }}>
                                <span className="fw-bold" style={{ fontSize: "14px", letterSpacing: "0.5px" }}>
                                    <i className="fas fa-file-invoice me-2"></i>FEE RECEIPT
                                </span>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-sm py-1 px-3"
                                        style={{ background: "#fff", color: "#6259ca", fontWeight: "bold", fontSize: "12px", borderRadius: "20px" }}
                                        onClick={handlePrint}>
                                        <i className="fas fa-print me-1"></i> Print
                                    </button>
                                    <button className="btn btn-sm py-1 px-2"
                                        style={{ background: "rgba(255,255,255,0.2)", color: "#fff", borderRadius: "50%", lineHeight: 1 }}
                                        onClick={() => setShowModal(false)}>
                                        <i className="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="modal-body p-0">
                                <div ref={printRef} className="receipt">

                                    {/* Receipt header — purple banner */}
                                    <div className="receipt-header" style={{ background: "#6259ca", color: "#fff", padding: "16px 20px" }}>
                                        {school && (
                                            <>
                                                <h2 style={{ margin: 0, fontSize: "17px", fontWeight: "bold" }}>{school.name}</h2>
                                                <p style={{ margin: "4px 0 0", fontSize: "12px", opacity: 0.85 }}>{school.address}</p>
                                            </>
                                        )}
                                        <div style={{
                                            display: "inline-block", marginTop: "8px", padding: "2px 12px",
                                            background: "rgba(255,255,255,0.2)", borderRadius: "12px",
                                            fontSize: "11px", letterSpacing: "1.5px", fontWeight: "bold"
                                        }}>
                                            PAYMENT RECEIPT
                                        </div>
                                    </div>

                                    {/* Receipt No + Date bar */}
                                    {invNo && (
                                        <div style={{
                                            background: "#f0effe", padding: "10px 20px",
                                            display: "flex", justifyContent: "space-between", alignItems: "center",
                                            borderBottom: "1px solid #ddd"
                                        }}>
                                            <div>
                                                <div style={{ fontSize: "10px", color: "#888", letterSpacing: "0.5px" }}>RECEIPT NO</div>
                                                <div style={{ fontWeight: "bold", color: "#6259ca", fontSize: "15px" }}>#{invNo.inv_no}</div>
                                            </div>
                                            <div style={{ textAlign: "right" }}>
                                                <div style={{ fontSize: "10px", color: "#888", letterSpacing: "0.5px" }}>DATE</div>
                                                <div style={{ fontWeight: "bold", fontSize: "13px" }}>{moment(invNo.payment_date).format("DD MMM YYYY")}</div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Student info block */}
                                    {invNo && (
                                        <div style={{ padding: "14px 20px", background: "#fff", borderBottom: "1px solid #eee" }}>
                                            <div style={{ fontSize: "10px", color: "#888", letterSpacing: "0.5px", marginBottom: "8px" }}>STUDENT DETAILS</div>
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px", fontSize: "12px" }}>
                                                <div><span style={{ color: "#999" }}>Name</span><br /><strong>{invNo.full_name}</strong></div>
                                                <div><span style={{ color: "#999" }}>Admission No</span><br /><strong>{invNo.admission_number}</strong></div>
                                                <div><span style={{ color: "#999" }}>Class</span><br /><strong>{invNo.class_name} – {invNo.section_name}</strong></div>
                                                <div><span style={{ color: "#999" }}>Roll No</span><br /><strong>{invNo.roll_number}</strong></div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Fee items table */}
                                    <div style={{ padding: "14px 20px" }}>
                                        <div style={{ fontSize: "10px", color: "#888", letterSpacing: "0.5px", marginBottom: "8px" }}>FEE DETAILS</div>
                                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                                            <thead>
                                                <tr style={{ background: "#6259ca", color: "#fff" }}>
                                                    <th style={{ padding: "8px 10px", textAlign: "left", borderRadius: "4px 0 0 0" }}>Particulars</th>
                                                    <th style={{ padding: "8px 10px", textAlign: "right", borderRadius: "0 4px 0 0" }}>Amount (₹)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {invData.map((fee, i) => (
                                                    <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#faf9ff" }}>
                                                        <td style={{ padding: "8px 10px", borderBottom: "1px solid #eee" }}>{fee.fee_type}</td>
                                                        <td style={{ padding: "8px 10px", textAlign: "right", borderBottom: "1px solid #eee" }}>
                                                            {parseFloat(fee.payment_amount).toFixed(2)}
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr style={{ background: "#f0effe" }}>
                                                    <td style={{ padding: "10px 10px", fontWeight: "bold", color: "#6259ca", borderTop: "2px solid #6259ca" }}>
                                                        Total
                                                    </td>
                                                    <td style={{ padding: "10px 10px", textAlign: "right", fontWeight: "bold", color: "#6259ca", borderTop: "2px solid #6259ca", fontSize: "15px" }}>
                                                        ₹{invTotal.toFixed(2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {/* In words */}
                                        <div style={{
                                            marginTop: "12px", padding: "8px 12px",
                                            background: "#f8f8f8", borderRadius: "6px",
                                            fontSize: "12px", color: "#555", fontStyle: "italic"
                                        }}>
                                            <strong>In Words:</strong> {numberToWords(Math.floor(invTotal))}
                                        </div>

                                        {/* PAID stamp + signature */}
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginTop: "20px" }}>
                                            <div style={{
                                                color: "#27ae60", fontWeight: "bold", fontSize: "18px",
                                                border: "2px solid #27ae60", padding: "2px 12px",
                                                borderRadius: "4px", opacity: 0.75, letterSpacing: "3px",
                                                transform: "rotate(-5deg)", display: "inline-block"
                                            }}>
                                                PAID
                                            </div>
                                            <div style={{ textAlign: "center" }}>
                                                <div style={{ width: "90px", borderTop: "1px solid #333", paddingTop: "4px", fontSize: "11px", color: "#555" }}>
                                                    Authorised Signature
                                                </div>
                                            </div>
                                        </div>

                                        {/* Note */}
                                        <p style={{ marginTop: "16px", fontSize: "10px", color: "#aaa", textAlign: "center", fontStyle: "italic" }}>
                                            * Paid fees will not be refunded under any circumstances.
                                        </p>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default FeeReport;
